export const createSuccessToast = {
  title:
    '$t(tracker:displayKind, {"context": "{{context}}" }) が追加されました',
};
